var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.275 19.8L0.5 14.025V5.775L6.275 0H14.525L20.3 5.775V14.025L14.525 19.8H6.275ZM7.265 14.575L10.4 11.44L13.535 14.575L15.075 13.035L11.94 9.9L15.075 6.765L13.535 5.225L10.4 8.36L7.265 5.225L5.725 6.765L8.86 9.9L5.725 13.035L7.265 14.575ZM7.21 17.6H13.59L18.1 13.09V6.71L13.59 2.2H7.21L2.7 6.71V13.09L7.21 17.6Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelar);
export default __webpack_public_path__ + "static/media/cancelar.0f4901ee66c96297412a626326ea3299.svg";
export { ForwardRef as ReactComponent };